export const DropdownMenuGroup = ({ children }) => {
  return <div className="py-1.5">{children}</div>;
};
